import { render } from "./VueTooltip.vue?vue&type=template&id=0bfde7d4"
import script from "./VueTooltip.vue?vue&type=script&lang=js"
export * from "./VueTooltip.vue?vue&type=script&lang=js"

import "./VueTooltip.vue?vue&type=style&index=0&id=0bfde7d4&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__